// pocket-addon.js — Cart drawer safe (intercepts /cart/add.js)
// Adds pocket add-on in the SAME request as the shirt when pocket checkbox is selected.
(function () {
  const POCKET_ADDON_VARIANT_ID = 51476838023300; // your $5 add-on variant id
  const POCKET_PROPERTY_KEY = "pocket_selection"; // checkbox => properties[pocket_selection]

  // Prevent recursion / double-processing
  let internalBypass = false;

  function makeUid() {
    return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
  }

  function hasPocketProperty(params) {
    const v = params.get(`properties[${POCKET_PROPERTY_KEY}]`);
    return v === "on" || v === "true" || v === "1" || v === "yes" || v === "Yes";
  }

  function extractAllProperties(params) {
    const props = {};
    for (const [k, v] of params.entries()) {
      if (k.startsWith("properties[") && k.endsWith("]")) {
        const name = k.slice("properties[".length, -1);
        props[name] = v;
      }
    }
    return props;
  }

  async function addBothAsJson(params) {
    const parentVariantId = params.get("id");
    const qty = parseInt(params.get("quantity") || "1", 10) || 1;

    const properties = extractAllProperties(params);

    // 🔥 This UID links the shirt line item to its pocket add-on line item
    const uid = makeUid();

    // Put UID on the PARENT item too
    properties._pocket_uid = uid;

    const payload = {
      items: [
        {
          id: Number(parentVariantId),
          quantity: qty,
          properties
        },
        {
          id: Number(POCKET_ADDON_VARIANT_ID),
          quantity: qty,
          properties: {
            _addon: "front_pocket",
            _source: POCKET_PROPERTY_KEY,
            _parent_uid: uid,
            _parent_variant_id: String(parentVariantId) // optional, just for debugging
          }
        }
      ]
    };

    internalBypass = true;
    try {
      return await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      });
    } finally {
      internalBypass = false;
    }
  }

  const _fetch = window.fetch;
  window.fetch = async function (input, init = {}) {
    if (internalBypass) return _fetch(input, init);

    const url = typeof input === "string" ? input : input?.url || "";
    const method = (init.method || "GET").toUpperCase();

    if (!url.includes("/cart/add") || method !== "POST") {
      return _fetch(input, init);
    }

    const contentType =
      (init.headers && (init.headers["Content-Type"] || init.headers.get?.("Content-Type"))) || "";

    if (String(contentType).includes("application/json")) {
      return _fetch(input, init);
    }

    const body = init.body;

    if (body instanceof FormData) {
      const params = new URLSearchParams();
      for (const [k, v] of body.entries()) params.append(k, v);

      if (!hasPocketProperty(params)) return _fetch(input, init);
      return addBothAsJson(params);
    }

    if (body instanceof URLSearchParams || typeof body === "string") {
      const params = body instanceof URLSearchParams ? body : new URLSearchParams(body);
      if (!hasPocketProperty(params)) return _fetch(input, init);
      return addBothAsJson(params);
    }

    return _fetch(input, init);
  };
})();
